import { Stack } from "@mui/material";
import { TableCardEntry } from "src/components/cards/senec-tile/dataTypes";
import {
    TableEntryIcon,
    TableEntryLabel,
    TableEntryValue,
} from "src/components/cards/senec-tile/table-card-content/TableCardElements";
import { useScreenSize } from "src/hooks/useScreenSize";
import { StackedCardContent } from "src/components/cards/senec-tile/table-card-content/stacked-card-content/StackedCardContent";

export interface FlexCardContentProps {
    data: TableCardEntry[];
    highlightLabel?: boolean;
}

export const FlexCardContent = ({ data, highlightLabel }: FlexCardContentProps) => {
    const { isMobile } = useScreenSize();

    return isMobile ? (
        <StackedCardContent data={data} highlightLabel={highlightLabel} />
    ) : (
        <Stack direction="row" justifyContent="flex-start" spacing={3} flexWrap="wrap" useFlexGap>
            {data.map((entry: TableCardEntry) => (
                <Stack key={"content-row-" + entry.label} data-testid={"content-row"} spacing="4px">
                    <TableEntryLabel data={entry} highlightLabel={highlightLabel} applyColor={false} />
                    <Stack direction={"row"} justifyContent={"left"} alignItems={"center"} spacing={1}>
                        <TableEntryValue data={entry} highlightLabel={highlightLabel} />
                        <TableEntryIcon data={entry} />
                    </Stack>
                </Stack>
            ))}
        </Stack>
    );
};
